module.exports = __webpack_public_path__ + "static/media/sapna.4c0cd17f.png";